import { Typography } from '@/ui';

import type { FC } from 'react';

interface Props {
  visible: boolean;
}

const MeetCoach: FC<Props> = ({ visible }) => {
  if (!visible) return null;

  return (
    <section
      aria-labelledby="matched-title"
      className="mt-6 flex flex-col gap-1"
    >
      <Typography component="h2" id="matched-title" variant="subtitle1">
        You’ve been matched!
      </Typography>
      <Typography className="max-w-[867px] text-cement-400">
        We matched you with two coaches we think can help you reach your goals.
        Book a 30-minute chemistry call with each to get to know each other
        better. Most people choose after two calls. We&apos;ll reach out to see
        how it went.
      </Typography>
    </section>
  );
};

export default MeetCoach;
